import Swiper from "swiper";
/**
 * informed
 * @constructor
 */
class Informed {
  constructor() {}
  /**
   * サンプル
   */
  init() {
    new Swiper('.swiper-container--informed', {
      loop: true,
      effect: "fade",
      speed: 800, //1秒かけながら次の画像へ移動
      autoplay: {
        delay: 3000, //2秒後に次の画像へ
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
    })
  }
};

export default Informed;
